export const SCREEN_NOTIFICATION_MODES = {
  WHOLE_SCREEN: 'whole_screen',
  BANNER: 'banner',
  OFF: 'off',
};

const SCREEN_NOTIFICATION_MODE_KEY = 'screenNotificationMode';
const SCREEN_NOTIFICATION_MODE_CHANGE_EVENT = 'screen-notification-mode-change';

// Legacy boolean preference used before the 3-state Screen Notification setting.
const LEGACY_TOAST_PREFERENCE_KEY = 'orderNotificationToastEnabled';

const isValidMode = (mode) =>
  Object.values(SCREEN_NOTIFICATION_MODES).includes(mode);

export const getScreenNotificationMode = () => {
  try {
    const stored = window.localStorage.getItem(SCREEN_NOTIFICATION_MODE_KEY);
    if (isValidMode(stored)) {
      return stored;
    }

    // Migrate the legacy boolean toast preference to the new mode.
    if (
      window.localStorage.getItem(LEGACY_TOAST_PREFERENCE_KEY) === 'true'
    ) {
      return SCREEN_NOTIFICATION_MODES.BANNER;
    }
  } catch {
    return SCREEN_NOTIFICATION_MODES.WHOLE_SCREEN;
  }

  return SCREEN_NOTIFICATION_MODES.WHOLE_SCREEN;
};

export const setScreenNotificationMode = (mode) => {
  const nextMode = isValidMode(mode)
    ? mode
    : SCREEN_NOTIFICATION_MODES.WHOLE_SCREEN;

  try {
    window.localStorage.setItem(SCREEN_NOTIFICATION_MODE_KEY, nextMode);
    // Keep the legacy key in sync so older sessions stay consistent.
    window.localStorage.setItem(
      LEGACY_TOAST_PREFERENCE_KEY,
      nextMode === SCREEN_NOTIFICATION_MODES.BANNER ? 'true' : 'false'
    );
  } catch {
    // Ignore localStorage failures so notifications keep working.
  }

  try {
    window.dispatchEvent(
      new CustomEvent(SCREEN_NOTIFICATION_MODE_CHANGE_EVENT, {
        detail: nextMode,
      })
    );
  } catch {
    // CustomEvent may be unavailable in non-browser environments.
  }

  return nextMode;
};

export const subscribeScreenNotificationMode = (callback) => {
  const handler = (event) => callback(event.detail);
  window.addEventListener(SCREEN_NOTIFICATION_MODE_CHANGE_EVENT, handler);

  return () => {
    window.removeEventListener(SCREEN_NOTIFICATION_MODE_CHANGE_EVENT, handler);
  };
};
